export const stars = [
  {
    id: "1",
    name: "林述",
    enName: "Lin Shu",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20handsome%20Chinese%20male%20actor%20in%20his%20thirties%2C%20calm%20confident%20expression%2C%20dark%20red%20studio%20background%2C%20soft%20dramatic%20lighting%2C%20editorial%20celebrity%20headshot%2C%20high%20detail%20cinematic%20quality&width=400&height=400&seq=pv-star-01&orientation=squarish",
    gender: "男",
    popularity: 9860,
    letter: "L",
    role: "实力派男演员",
    bio: "出道十五年，从文艺片到商业大片皆有代表作。以细腻克制的表演风格著称，多次入围华语电影重要奖项。近年专注塑造有血有肉的都市男性角色。",
    works: ["烈火之心", "血色浪漫", "南风知我意"],
  },
  {
    id: "2",
    name: "苏晚棠",
    enName: "Su Wantang",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20elegant%20Chinese%20actress%20with%20soft%20wavy%20hair%2C%20warm%20gentle%20expression%2C%20muted%20crimson%20studio%20background%2C%20soft%20editorial%20lighting%2C%20refined%20celebrity%20headshot%2C%20high%20detail%20cinematic%20quality&width=400&height=400&seq=pv-star-02&orientation=squarish",
    gender: "女",
    popularity: 9420,
    letter: "S",
    role: "人气女演员",
    bio: "凭借都市情感剧走红，气质温婉又自带锋芒。擅长诠释独立女性角色，被观众称为“最有故事感的女主角”。同时也是话剧舞台上的常客。",
    works: ["烈火之心", "都市迷情", "霓虹之下"],
  },
  {
    id: "3",
    name: "顾承川",
    enName: "Gu Chengchuan",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20mature%20Chinese%20male%20actor%20with%20sharp%20features%20and%20slight%20stubble%2C%20intense%20serious%20gaze%2C%20dark%20charcoal%20and%20crimson%20studio%20background%2C%20dramatic%20lighting%2C%20premium%20celebrity%20headshot&width=400&height=400&seq=pv-star-03&orientation=squarish",
    gender: "男",
    popularity: 8710,
    letter: "G",
    role: "悬疑题材熟脸",
    bio: "以硬朗外形和强大气场为人熟知，是悬疑与犯罪题材的常客。曾塑造多个亦正亦邪的复杂角色，被认为是最具“电影感”的男演员之一。",
    works: ["暗夜玫瑰", "罪爱双生", "长夜燃灯"],
  },
  {
    id: "4",
    name: "白鹿鸣",
    enName: "Bai Luming",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20stylish%20Chinese%20actress%20with%20short%20modern%20hair%2C%20playful%20confident%20smile%2C%20warm%20amber%20and%20red%20studio%20background%2C%20vibrant%20editorial%20lighting%2C%20contemporary%20celebrity%20headshot&width=400&height=400&seq=pv-star-04&orientation=squarish",
    gender: "女",
    popularity: 8230,
    letter: "B",
    role: "新生代女演员",
    bio: "从网络剧走出的新锐女演员，风格鲜明、可塑性强。既能在文艺片里安静克制，也能在都市剧里明艳张扬，是近年最受关注的年轻面孔之一。",
    works: ["炽爱迷宫", "霓虹之下", "深海之吻"],
  },
  {
    id: "5",
    name: "江砚",
    enName: "Jiang Yan",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20refined%20Chinese%20male%20actor%20in%20a%20classic%20dark%20suit%2C%20warm%20thoughtful%20expression%2C%20deep%20red%20gradient%20studio%20background%2C%20elegant%20soft%20lighting%2C%20editorial%20celebrity%20headshot&width=400&height=400&seq=pv-star-05&orientation=squarish",
    gender: "男",
    popularity: 7980,
    letter: "J",
    role: "年代戏男主角",
    bio: "以年代剧和古装剧见长，身上自带一种旧时光的沉稳气质。台词功底扎实，擅长演绎在时代洪流中坚守信念的角色。",
    works: ["血色浪漫", "南风知我意", "暗夜玫瑰"],
  },
  {
    id: "6",
    name: "温以宁",
    enName: "Wen Yining",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20serene%20Chinese%20actress%20with%20long%20straight%20hair%2C%20gentle%20melancholic%20expression%2C%20soft%20muted%20rose%20studio%20background%2C%20delicate%20editorial%20lighting%2C%20artistic%20celebrity%20headshot&width=400&height=400&seq=pv-star-06&orientation=squarish",
    gender: "女",
    popularity: 7640,
    letter: "W",
    role: "文艺气质女演员",
    bio: "气质清冷、擅长情绪戏，是文艺片导演心中的理想人选。角色多以隐忍坚韧的女性为主，表演细腻有层次，被赞“眼神会演戏”。",
    works: ["深海之吻", "逆光之恋", "烈火之心"],
  },
  {
    id: "7",
    name: "陆时衍",
    enName: "Lu Shiyan",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20sophisticated%20Chinese%20male%20actor%20in%20a%20slim%20turtleneck%2C%20cool%20composed%20expression%2C%20dark%20warm%20red%20studio%20background%2C%20modern%20editorial%20lighting%2C%20high%20end%20celebrity%20headshot&width=400&height=400&seq=pv-star-07&orientation=squarish",
    gender: "男",
    popularity: 7210,
    letter: "L",
    role: "都市剧男神",
    bio: "都市剧里的熟面孔，气质疏离又迷人。既能驾驭精英律师、投资人等角色，也在惊悚短片中展现了截然不同的一面。",
    works: ["都市迷情", "长夜燃灯", "燃情岁月"],
  },
  {
    id: "8",
    name: "沈书瑶",
    enName: "Shen Shuyao",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20elegant%20mature%20Chinese%20actress%20with%20sleek%20hair%2C%20commanding%20intelligent%20expression%2C%20deep%20crimson%20studio%20background%2C%20dramatic%20editorial%20lighting%2C%20powerful%20celebrity%20headshot&width=400&height=400&seq=pv-star-08&orientation=squarish",
    gender: "女",
    popularity: 6890,
    letter: "S",
    role: "双面演技派",
    bio: "以一人分饰两角的高难度角色惊艳观众，戏路宽广。既演得了年代剧里坚韧的母亲，也撑得起悬疑剧里阴郁的对手。",
    works: ["罪爱双生", "燃情岁月", "暗夜玫瑰"],
  },
  {
    id: "9",
    name: "韩行舟",
    enName: "Han Xingzhou",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20energetic%20Chinese%20male%20actor%20with%20messy%20styled%20hair%2C%20bright%20youthful%20smile%2C%20warm%20amber%20and%20red%20studio%20background%2C%20vibrant%20editorial%20lighting%2C%20modern%20celebrity%20headshot&width=400&height=400&seq=pv-star-09&orientation=squarish",
    gender: "男",
    popularity: 6620,
    letter: "H",
    role: "青春偶像新星",
    bio: "自带少年感的阳光男演员，是青春校园题材的热门人选。私下热爱音乐与街头文化，把舞台和镜头都玩得很有个人风格。",
    works: ["霓虹之下", "逆光之恋", "都市迷情"],
  },
  {
    id: "10",
    name: "叶知秋",
    enName: "Ye Zhiqiu",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20graceful%20Chinese%20actress%20in%20traditional%20styled%20modern%20attire%2C%20serene%20poised%20expression%2C%20warm%20red%20and%20gold%20studio%20background%2C%20elegant%20soft%20lighting%2C%20refined%20celebrity%20headshot&width=400&height=400&seq=pv-star-10&orientation=squarish",
    gender: "女",
    popularity: 6410,
    letter: "Y",
    role: "古装美人",
    bio: "古典气质出众，是古装剧与年代剧的宠儿。一袭红衣的造型被观众反复截图讨论，被称为“从画里走出来的人”。",
    works: ["南风知我意", "血色浪漫"],
  },
];